import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import DropdownBar from '@ifca-root/react-component/src/components/SpecialBar/DropdownBar'
import { SearchBar } from '@ifca-root/react-component/src/components/SpecialBar/SearchBar'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import {
  useGetUsersByAccountAndSoftwareQuery,
  useGetIncreaseOriginalAmountStatusListingLazyQuery,
} from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { IncreaseOriginalValueEntryList } from './IncreaseOriginalValueList/IncreaseOriginalValueEntryList'
import { IncreaseOriginalValuePostingList } from './IncreaseOriginalValueList/IncreaseOriginalValuePostingList'

export const IncreaseOriginalValueMain = (props: any) => {
  let history = useHistory()
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  /* -------------------------------------------- */
  /*                   VARIABLES                  */
  /* -------------------------------------------- */

  const approvalStatusEnum = [
    { name: 'Draft', ID: 'ACTIVE' },
    { name: 'Submitted', ID: 'SUBMIT' },
    { name: 'Approved', ID: 'COMPLETED' },
    { name: 'Rejected', ID: 'REJECTED' },
    { name: 'All', ID: 'ALL' },
  ]

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */

  const [postIDs, setPostIDs] = useState<Set<any>>(new Set([]))
  const [openExitConf, setOpenExitConf] = useState(null)
  const [listStatus, setListStatus] = useState<string>(
    getSearch?.option ?? 'ACTIVE'
  )
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  const [
    loadData,
    { loading: dataLoading, fetchMore },
  ] = useGetIncreaseOriginalAmountStatusListingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      const error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getIncreaseOriginalAmountStatusListing }) => {
      if (getIncreaseOriginalAmountStatusListing?.Data?.length > 0) {
        setOriginalListing([
          ...filteredList,
          ...getIncreaseOriginalAmountStatusListing?.Data,
        ])
      }
    },
  })

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({ fetchPolicy: 'network-only' })

  /* -------------------------------------------- */
  /*                    SEARCH                    */
  /* -------------------------------------------- */

  const { filteredList, handleSearch, setOriginalListing } = useFuseSearch()

  const hasChanges = () => {
    if (postIDs?.size === 0) return false
    else return true
  }

  /* -------------------------------------------- */
  /*                   USE EFFECT                 */
  /* -------------------------------------------- */

  useEffect(() => {
    setOriginalListing([])
    setPostIDs(new Set([]))
    loadData({
      variables: {
        CompanyID: CompanyID,
        StatusArr:
          listStatus === 'ALL'
            ? ['ACTIVE', 'SUBMIT', 'COMPLETED', 'REJECTED']
            : [listStatus],
        take: 30,
        skip: 0,
        searchValue:
          getSearch?.name === '' || getSearch?.name === undefined
            ? undefined
            : getSearch?.name,
      },
    })
  }, [listStatus])

  return (
    <>
      {UserLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          hasChanges() === true && listStatus === 'SUBMIT'
            ? setOpenExitConf(true)
            : history.push(`/fixed-assets/${CompanyID}/assets-change`)
          localStorage.removeItem(`searchFilter`)
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Increase in Original Value', current: true },
        ]}
      />

      <div className="search-filter with-dropdown-filter ">
        <SearchBar
          borderRadius="4px"
          onChangeAction={e => {
            setOriginalListing([])
            loadData({
              variables: {
                CompanyID: CompanyID,
                StatusArr:
                  listStatus === 'ALL'
                    ? ['ACTIVE', 'SUBMIT', 'COMPLETED', 'REJECTED']
                    : [listStatus],
                take: 30,
                skip: 0,
                searchValue: e?.target?.value || undefined,
              },
            })
          }}
          defaultValue={getSearch?.name ? getSearch?.name : ''}
          onCloseAction={() => {
            handleSearch('', [])
            setOriginalListing([])
            loadData({
              variables: {
                CompanyID: CompanyID,
                StatusArr:
                  listStatus === 'ALL'
                    ? ['ACTIVE', 'SUBMIT', 'COMPLETED', 'REJECTED']
                    : [listStatus],
                take: 30,
                skip: 0,
                searchValue: undefined,
              },
            })
          }}
          isDefaultValue={!!getSearch?.name}
        />

        <DropdownBar
          options={approvalStatusEnum}
          setOptionID={setListStatus}
          borderRadius="4px"
          defaultOption={approvalStatusEnum
            ?.map(opt => opt?.ID)
            .indexOf(listStatus ?? 'ACTIVE')}
          searchFilter={getSearch}
        />
      </div>

      {(listStatus === 'ACTIVE' ||
        listStatus === 'COMPLETED' ||
        listStatus === 'REJECTED' ||
        listStatus === 'ALL') && (
        <IncreaseOriginalValueEntryList
          filteredList={filteredList}
          listStatus={listStatus}
          listLoading={dataLoading}
          fetchMore={loadData}
          userList={getUsersByAccountAndSoftware}
          setOriginalListing={setOriginalListing}
        />
      )}

      {listStatus === 'SUBMIT' && (
        <IncreaseOriginalValuePostingList
          filteredList={filteredList}
          listStatus={listStatus}
          listLoading={dataLoading}
          fetchMore={loadData}
          userList={getUsersByAccountAndSoftware}
          setOriginalListing={setOriginalListing}
          postIDs={postIDs}
          setPostIDs={setPostIDs}
          CompanyID={CompanyID}
        />
      )}

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/fixed-assets/${CompanyID}`)
        }}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
